var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", [
    _c(
      "div",
      {
        staticClass: "tm-hero",
        style: {
          backgroundImage: "url('" + require("@/assets/hero.jpg") + "')"
        }
      },
      [
        _c("div", { staticClass: "tm-hero__content container" }, [
          _c("img", {
            staticClass: "tm-hero__logo",
            attrs: {
              src: require("@/assets/logo-white.svg"),
              "data-aos": "zoom-in-up"
            }
          }),
          _c(
            "h2",
            {
              staticClass:
                "tm-hero__subtext text-white text-shadow-stylish my-5 text-center",
              attrs: { "data-aos": "zoom-in-up", "data-aos-delay": "300" }
            },
            [_vm._v("The world's largest music streaming platform.")]
          ),
          _c(
            "div",
            { attrs: { "data-aos": "zoom-in-up", "data-aos-delay": "600" } },
            [
              _c(
                "router-link",
                {
                  staticClass:
                    "tm-btn bg-white tm-btn--animated--rise text-primary tm-btn--round",
                  attrs: { to: "/guide" }
                },
                [_vm._v("Learn more")]
              )
            ],
            1
          )
        ]),
        _c("img", {
          staticClass: "tm-hero__wave",
          attrs: { src: require("@/assets/hero-wave.svg") }
        })
      ]
    ),
    _c("div", { staticClass: "tm-zebra" }, [
      _vm._m(0),
      _c("img", {
        staticClass: "tm-zebra__img",
        attrs: { src: require("@/assets/wave-1.svg") }
      }),
      _c(
        "div",
        { staticClass: "tm-zebra__foal tm-section tm-section--padded--t-more" },
        [
          _c("div", { staticClass: "container" }, [
            _c("div", { staticClass: "row align-items" }, [
              _c(
                "div",
                {
                  staticClass:
                    "col-lg-6 col-md-7 py-4 col-12 d-flex align-items-center"
                },
                [
                  _c("div", [
                    _c(
                      "h4",
                      {
                        staticClass: "tm-giant-title font-weight-bold mb-5",
                        attrs: { "data-aos": "fade-right" }
                      },
                      [_vm._v("The high quality music you deserve  ")]
                    ),
                    _c(
                      "div",
                      { attrs: { "data-aos": "fade-right" } },
                      [
                        _c(
                          "router-link",
                          {
                            staticClass:
                              "tm-btn tm-btn--primary tm-btn--round tm-btn--animated--rise",
                            attrs: { to: "/guide" }
                          },
                          [_vm._v("Download          ")]
                        )
                      ],
                      1
                    )
                  ])
                ]
              ),
              _vm._m(1)
            ])
          ])
        ]
      ),
      _c("img", {
        staticClass: "tm-zebra__img rotate-180",
        attrs: { src: require("@/assets/white-wave.svg") }
      }),
      _c(
        "div",
        { staticClass: "tm-zebra__foal tm-section tm-section--padded--b-more" },
        [
          _c("div", { staticClass: "container" }, [
            _c("div", { staticClass: "row align-items" }, [
              _vm._m(2),
              _c(
                "div",
                {
                  staticClass:
                    "col-lg-6 col-md-7 py-4 col-12 d-flex align-items-center"
                },
                [
                  _c("div", [
                    _c(
                      "h6",
                      {
                        staticClass: "tm-giant-subtitle text-right",
                        attrs: { "data-aos": "fade-left" }
                      },
                      [_vm._v("Guide")]
                    ),
                    _c(
                      "h4",
                      {
                        staticClass:
                          "tm-giant-title font-weight-bold mb-5 text-right",
                        attrs: { "data-aos": "fade-left" }
                      },
                      [_vm._v("We'll help you along the way ")]
                    ),
                    _c(
                      "div",
                      { attrs: { "data-aos": "fade-left" } },
                      [
                        _c(
                          "router-link",
                          {
                            staticClass:
                              "tm-btn float-right tm-btn--primary tm-btn--round tm-btn--animated--rise",
                            attrs: { to: "/guide" }
                          },
                          [_vm._v("View our guide    ")]
                        )
                      ],
                      1
                    )
                  ])
                ]
              )
            ])
          ])
        ]
      ),
      _c("img", {
        staticClass: "tm-zebra__img",
        attrs: { src: require("@/assets/white-wave.svg") }
      }),
      _c(
        "div",
        { staticClass: "tm-zebra__foal tm-section tm-section--padded--b-more" },
        [
          _c("div", { staticClass: "container" }, [
            _c(
              "div",
              {
                staticClass: "row align-items flex-column-reverse flex-md-row"
              },
              [
                _c(
                  "div",
                  {
                    staticClass:
                      "col-lg-7 col-md-7 py-4 col-12 d-flex align-items-center"
                  },
                  [
                    _c("div", [
                      _c(
                        "h6",
                        {
                          staticClass: "tm-giant-subtitle",
                          attrs: { "data-aos": "fade-right" }
                        },
                        [_vm._v("Developers")]
                      ),
                      _c(
                        "h4",
                        {
                          staticClass: "tm-giant-title font-weight-bold mb-5",
                          attrs: { "data-aos": "fade-right" }
                        },
                        [_vm._v("A powerful new API at your fingertips.")]
                      ),
                      _c(
                        "div",
                        { attrs: { "data-aos": "fade-right" } },
                        [
                          _c(
                            "router-link",
                            {
                              staticClass:
                                "tm-btn tm-btn--primary tm-btn--round tm-btn--animated--rise",
                              attrs: { to: "/guide" }
                            },
                            [_vm._v("Read more   ")]
                          )
                        ],
                        1
                      )
                    ])
                  ]
                ),
                _vm._m(3)
              ]
            )
          ])
        ]
      ),
      _c("img", {
        staticClass: "tm-zebra__img rotate-180",
        attrs: { src: require("@/assets/white-wave.svg") }
      }),
      _c(
        "div",
        { staticClass: "tm-zebra__foal tm-section tm-section--padded--t-more" },
        [
          _c("div", { staticClass: "container" }, [
            _vm._m(4),
            _c(
              "div",
              { staticClass: "row" },
              _vm._l(_vm.plans, function(plan, index) {
                return _c("tm-plan-card", {
                  key: plan.title,
                  staticClass: "col-lg-4 mb-5",
                  attrs: {
                    "data-aos": plan.aos,
                    "data-aos-delay": plan.aosDelay,
                    title: plan.title,
                    price: plan.price,
                    description: plan.description,
                    points: plan.points
                  }
                })
              }),
              1
            )
          ])
        ]
      )
    ])
  ])
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c(
      "div",
      { staticClass: "tm-zebra__foal tm-section tm-section--padded--b-more" },
      [
        _c("div", { staticClass: "container" }, [
          _c("div", { staticClass: "row" }, [
            _c("div", { staticClass: "col-md-4 mb-5 mb-md-0" }, [
              _c(
                "div",
                {
                  staticClass: "tm-feature",
                  attrs: { "data-aos": "zoom-in-up", "data-aos-delay": "300" }
                },
                [
                  _c("i", {
                    staticClass: "tm-feature__icon fas fa-headphones"
                  }),
                  _c("h3", { staticClass: "tm-feature__title" }, [
                    _vm._v("Superior Sound Quality          ")
                  ]),
                  _c("p", { staticClass: "tm-feature__subtext" }, [
                    _vm._v(
                      "We deliver the highest quality sounds straight through your headphones."
                    )
                  ])
                ]
              )
            ]),
            _c("div", { staticClass: "col-md-4 mb-5 mb-md-0" }, [
              _c(
                "div",
                {
                  staticClass: "tm-feature",
                  attrs: { "data-aos": "zoom-in-up", "data-aos-delay": "600" }
                },
                [
                  _c("i", { staticClass: "tm-feature__icon far fa-chart-bar" }),
                  _c("h3", { staticClass: "tm-feature__title" }, [
                    _vm._v("Data Analytics")
                  ]),
                  _c("p", { staticClass: "tm-feature__subtext" }, [
                    _vm._v(
                      "Gain access to analytics about your listening habits."
                    )
                  ])
                ]
              )
            ]),
            _c("div", { staticClass: "col-md-4" }, [
              _c(
                "div",
                {
                  staticClass: "tm-feature",
                  attrs: { "data-aos": "zoom-in-up", "data-aos-delay": "900" }
                },
                [
                  _c("i", { staticClass: "tm-feature__icon fas fa-music" }),
                  _c("h3", { staticClass: "tm-feature__title" }, [
                    _vm._v("Massive Library")
                  ]),
                  _c("p", { staticClass: "tm-feature__subtext" }, [
                    _vm._v(
                      "Listen to your old favourites and discover new ones. "
                    )
                  ])
                ]
              )
            ])
          ])
        ])
      ]
    )
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "col-lg-6 col-md-5 py-4 col-12" }, [
      _c("img", {
        staticClass: "w-100",
        attrs: {
          src: require("@/assets/hq-companion.png"),
          "data-aos": "fade-left"
        }
      })
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "col-lg-6 col-md-5 py-4 col-12" }, [
      _c("img", {
        staticClass: "w-100",
        attrs: {
          src: require("@/assets/guide-companion.png"),
          "data-aos": "fade-right"
        }
      })
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c(
      "div",
      {
        staticClass:
          "col-lg-5 col-md-5 py-4 col-12 d-flex align-items-center justify-content-center"
      },
      [
        _c("img", {
          attrs: {
            id: "apiPic",
            src: require("@/assets/tamsin-io-black-api.svg"),
            "data-aos": "fade-left"
          }
        })
      ]
    )
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "row" }, [
      _c(
        "div",
        { staticClass: "col-12", attrs: { "data-aos": "zoom-in-down" } },
        [
          _c("h6", { staticClass: "tm-section__subtitle mb-2" }, [
            _vm._v("Let's Get Started")
          ]),
          _c("h2", { staticClass: "tm-section__title mb-4" }, [_vm._v("Plans")])
        ]
      )
    ])
  }
]
render._withStripped = true

export { render, staticRenderFns }